module.exports = __webpack_public_path__ + "static/stepan-f9843ba6bb7dbae987249779d62ad8c0.png";